import React from "react";
import defaultImg from "../../assets/images/select_image.png";
import getEnvironmentImageSrc from "../../getEnvironmentImageSrc";
import {
  ENV_THUMB_HEIGHT,
  ENV_THUMB_WIDTH,
} from "../../admin/environmentsGridUtils";

const EnvironmentThumbnail = ({ environment, alt }) => {
  const src = getEnvironmentImageSrc(environment) || defaultImg;

  return (
    <div
      style={{
        width: `${ENV_THUMB_WIDTH}px`,
        height: `${ENV_THUMB_HEIGHT}px`,
        borderRadius: "8px",
        overflow: "hidden",
        border: "1px solid #e2e8f0",
        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.12)",
        backgroundColor: "#f8fafc",
        flexShrink: 0,
      }}
    >
      <img
        src={src}
        alt={alt || environment?.name || "Environment"}
        onError={(e) => {
          e.currentTarget.src = defaultImg;
        }}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
          display: "block",
        }}
      />
    </div>
  );
};

export default EnvironmentThumbnail;
